/**
 * Created by federuiz on 7/13/17.
 */
export const CALLE = 0;
export const CALLE_ALTURA = 1;
export const CALLE_Y_CALLE = 2;
export const INVALIDO = -1;
export const DIRECCION_CALLE_ALTURA = 0;
export const DIRECCION_CALLE_Y_CALLE = 1;

export const EXCEPCION_CALLE_INVALIDA = 0;
export const EXCEPCION_ALTURA_INVALIDA = 1;
export const EXCEPCION_CARGA_CALLEJERO = 2;
export const EXCEPCION_CALLE_SIN_ALTURAS = 3;
export const EXCEPCION_CRUCE_INEXISTENTE = 4;



// WEBPACK FOOTER //
// ./src/constants.js